<template>
    <div class="color">
        <button
            class="color__circle"
            :style="{ backgroundColor: colorValue }"
            type="button"
            @click="colorPickerVisible = !colorPickerVisible"
        />

        <div class="color__text">
            <span
                class="color__input"
                contenteditable
                @blur="onInput"
                v-text="colorLabel"
            />
        </div>

        <div class="color__info">
            <span class="color__value">{{ colorValue }}</span>

            <button
                class="color__wheel"
                type="button"
                @click="colorPickerVisible = !colorPickerVisible"
            >
                <img :src="require('@/assets/ui/color-wheel.svg')">
            </button>

            <chrome-picker
                v-if="colorPickerVisible"
                v-on-clickaway="onClickAway"
                class="color__picker"
                :value="colorValue"
                tabindex="0"
                @input="onColorPickerSelect"
            />
        </div>
    </div>
</template>

<script>
import { Chrome } from '@xcentium/vue-color';
import { mixin as clickaway } from 'vue-clickaway';

export default {
    name: 'settings-color',
    components: { 'chrome-picker': Chrome },
    mixins: [clickaway],

    props: {
        color: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            colorLabel: this.color.displayName,
            colorValue: this.color.value,
            colorPickerVisible: false,
        };
    },

    methods: {
        onClickAway() {
            this.colorPickerVisible = false;
            this.onUpdate();
        },

        onColorPickerSelect(color) {
            this.colorValue = color.hex;
        },

        onInput(e) {
            this.colorLabel = e.target.innerText;
            this.onUpdate();
        },

        onUpdate() {
            this.$emit('input', {
                name: this.color.name,
                displayName: this.colorLabel?.replace(/^[\r\n]+$/, '').trim(),
                value: this.colorValue,
            });
        },
    },
};
</script>

<style lang="scss">
.color {
    $this: &;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 160px;
    min-width: 160px;

    &__circle {
        width: 72px;
        height: 72px;
        border-radius: 50%;
        margin-bottom: 8px;
        border: 1px solid #edf2f7;
    }

    &__text {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    &__input {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        padding: 2px 4px;
        border: 1px solid transparent;
        border-bottom-color: var(--form-inputBorderColor);
        transition: border-color 0.4s ease;

        &:focus {
            border-color: var(--form-inputBorderColor);
        }
    }

    &__info {
        display: flex;
        align-items: center;
        position: relative;
        min-width: 87px;
    }

    &__value {
        display: inline-block;
        text-transform: uppercase;
        font-size: 14px;
        text-align: center;
    }

    &__wheel {
        margin-left: 10px;
    }

    &__picker {
        font-family: $default-font-family;
        position: absolute;
        z-index: 100;
        margin-top: 36px;
        left: 36px;

        .vc-chrome-toggle-icon svg {
            margin-left: 12px;
        }

        .vc-chrome-hue-wrap {
            margin-top: 10px;
            width: 95%;
            left: 5%;
        }

        .vc-chrome-alpha-wrap {
            display: none;
        }
    }
}
</style>
